export type SavedChartOption = {
  _id: string;
  birthDetails?: {
    name?: string;
    dateOfBirth?: string;
    timeOfBirth?: string;
    placeOfBirth?: { name?: string; latitude?: number; longitude?: number };
  };
};

// Follow API pagination rather than treating the first 50 charts as the full library.
export async function loadSavedChartOptions(apiBaseUrl: string, token: string, signal: AbortSignal): Promise<SavedChartOption[]> {
  const charts = new Map<string, SavedChartOption>();
  let page = 1;
  let hasNext = true;
  while (hasNext) {
    const response = await fetch(`${apiBaseUrl}/charts/my-charts?page=${page}&limit=50&type=individual&summary=true`, {
      headers: { Authorization: `Bearer ${token}` },
      signal,
    });
    const body = await response.json();
    if (!response.ok) throw new Error(body.message || 'Could not load saved charts.');
    const batch: SavedChartOption[] = body.data?.charts || [];
    batch.forEach(chart => charts.set(chart._id, chart));
    const pagination = body.data?.pagination;
    hasNext = pagination?.hasNext ?? (page < (pagination?.pages || 1));
    if (hasNext && batch.length === 0) throw new Error('Could not load the complete saved chart list. Please try again.');
    page += 1;
  }
  return Array.from(charts.values());
}
